<div [ngClass]="_pannelClass">
	<div class="panel-heading clickable" (click)="toggleDisplay()">
		<ng-container
			*ngTemplateOutlet="(headerTemplate ? headerTemplate : defaultHeaderTemplate); context: { 'title': title, 'expandable': expandable, 'folded': folded }"
			>
		</ng-container>
	</div>
	<div class="panel-body" [hidden]="folded">
		<ng-content></ng-content>
	</div>
</div>

<ng-template #defaultHeaderTemplate>
	<h2>{{ title }}</h2>
	<button *ngIf="expandable" class="btn btn-primary btn-sm pull-right">
		<span>{{ folded ? 'Afficher' : 'Masquer' }}</span>
	</button>
</ng-template>